"use client";

/* eslint-disable jsx-a11y/anchor-is-valid */
import { IUrlInformation } from "api/interfaces/get-page-details/get-page-details.type";
import { IMakeModelYearActualResponse, IMakeModelYearPageContent } from "api/interfaces/get-page-details/make-model-year-page.type";
import NewPageHeader from "component/banner/NewPageHeader";
import { RootState } from "interfaces/generics.type";
import { useRouter } from "next/router";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { equalVehicles } from "util/vehicle/equal-vehicles";
import { validateVehicle } from "util/vehicle/validate-vehicle";
import { addVehicle } from "../../action/garage/addVehicle";
import PageContainer from "../components/PageContainer";
import DynamicOrderComponents from "./DynamicOrderComponents";
import MetaHead from "./common/MetaHead";

interface IProps{
  urlInformation: IUrlInformation;
  staticContent: IMakeModelYearPageContent;
  actualResponse: IMakeModelYearActualResponse;
}
function MakeModelYearPage(props: IProps) {
  const {
    staticContent,
    urlInformation, actualResponse,
  } = props;

  const { breadCrumbsV2, tiersYearMakeModelPagesWithUrl } = actualResponse;

  const { pageStructure, pageDetails, relatedProducts } = staticContent;

  const {
    displayableMake, displayableModel, pageDisplayableTitle,
  } = pageDetails || {};

  const { make, model, year } = urlInformation;
  const dispatch = useDispatch();
  const { selectedVehicle } = useSelector((store: RootState) => store.garage);
  const router = useRouter();
  const { asPath } = router;

  useEffect(() => {
    dispatch(addVehicle(urlInformation));
  }, [asPath]);

  useEffect(() => {
    const vehicleFromUrlInfo = {
      make, model, year, fitmentOptions: [],
    };
    if (validateVehicle(selectedVehicle) && !equalVehicles(selectedVehicle, { ...vehicleFromUrlInfo })) {
      router.push("/#regular-service");
    }
  }, [selectedVehicle]);

  if (!actualResponse) {
    return null;
  }
  let pageContainer;

  if (pageStructure && pageStructure.length) {
    pageContainer = (
      <DynamicOrderComponents
        {...{
          make,
          model,
          relatedProducts,
          displayableMake,
          displayableModel,
          displayableYear: year,
          tiersYearMakeModelPagesWithUrl,
          pageStructure,
        }}
      />
    );
  }

  return (
    <PageContainer ShowGreyOuterContainer>

      <MetaHead
        {...{
          ...staticContent.metaData,
          ...staticContent.pageDetails,
          breadCrumbsList: breadCrumbsV2[0] || [],
        }}
      />
      <NewPageHeader
        staticContent={staticContent}
        breadCrumbsV2={breadCrumbsV2}
        pageDisplayableTitle={pageDisplayableTitle}
      />
      {pageContainer}

    </PageContainer>
  );
}

export default MakeModelYearPage;
